import * as React from 'react'
import { Button, Form, Image } from 'react-bootstrap'
import * as _ from 'lodash'
import config from '../../../../constants/config'
import images from '../../../../constants/images'
import ButtonUploadImage from '../../../../components/ButtonUploadImage'
import InputPhone from '../../../../components/InputPhone'

import { JobMode } from '../Job'
import { copyObject } from '../../../../utils'
import { AxiosInstance, uploadFileServer } from '../../../../utils/RequestMethods'

import { ClientObj, ClientT } from '../../../../types/Users'


import ButtonLoading from '../../../../components/ButtonLoading/ButtonLoading'
import InputSearchUsers from '../../../../components/InputSearchUsers/InputSearchUsers'
import InputAutoComplete from '../../../../components/InputAutoComplete/InputAutoComplete'
import InputSearchClients from './InputSearchClients'
import { useImmer } from 'use-immer'
import ChangePassword from './ChangePassword'
import { JobT } from '../../../../types/Job'
import GoogleMapAutoComplete from '../../../../components/MapBoxAutoComplete/GoogleMapAutoComplete'




export type IFormEditClientProps = {
    client: ClientT

    jobMode?: JobMode
    typeClient: "primary" | "billing"
    keyInJob: "client" | "billingContact"
    isBillingContact?: boolean
    updateJob(key: string, value: any): void
    customSaveJob?(args: JobT): Promise<JobT>
    // clientId?: number
}

const FormEditClient: React.FC<IFormEditClientProps> = (props) => {
    const [isReady, setIsReady] = React.useState(false)
    const [disabled, setDisabled] = React.useState(false);
    const [isChange, setIsChange] = React.useState(false);
    const [mode, setMode] = React.useState("new");
    const [fieldsClient, setFieldsClient] = useImmer(ClientObj);
    const [fieldsClientDirty, setFieldsClientDirty] = useImmer(ClientObj);
    const [fieldsDirty, setFieldsDirty] = React.useState({})
    const [action, setAction] = React.useState(null);


    React.useEffect(() => {
        if (props.jobMode == JobMode.Dispute) {
            setDisabled(true)
        }
    }, []);
    React.useEffect(() => {
        setIsReady(true)

        /**
         * if action null
         * no in mode change
         * update fields client from receive object job
         */
        if (action == null && !_.isEqual(props.client, fieldsClient)) {
            console.log("update-client")
            updateAllFields(props.client)

            if (props.client.id != null) {
                setMode("edit")
            }
        }

    }, [props.client])

    // React.useEffect(() => {
    //     // console.log("props.jobMode",props.jobMode)
    //     // if (props.jobMode == JobMode.New) {
    //     Object.keys(props.client).map((key, index) => {
    //         setFieldsClient((dreft) => {
    //             dreft[key] = props.client[key]
    //         })
    //     })
    //     // }

    // }, [props.jobMode])




    const updateAllFields = (data: ClientT) => {
        Object.keys(data).map((key, index) => {
            setFieldsClient((dreft) => {
                dreft[key] = data[key]
            })
        })
    }


    /**
        *
        * @param key
        * @param value
        */
    const updateClient = (key: string, value: any): void => {

        setFieldsClient((draft) => {
            draft[key] = value
        })

        let cloneFieldsDirty = copyObject(fieldsDirty)
        cloneFieldsDirty[key] = value
        setFieldsDirty(cloneFieldsDirty)
        // setFieldsDirty((draft) => {
        //     draft[key] = value
        //     return draft
        // })
        let clientClone = copyObject(props.client)
        clientClone[key] = value

        props.updateJob(props.keyInJob, clientClone)
    }


    /**
     *
     */
    const restState = () => {

        setFieldsDirty({})
        toggalMode(false)
        setIsChange(false)

        setAction(null)

    }
    /**
     *
     * @param edit
     */
    const toggalMode = (edit = false) => {
        // setDisabled(!edit)
        setIsChange(edit)
    }

    /**
     *
     * @param fields
     */
    const setAllFieldsClient = (fields: ClientT) => {
        Object.keys(ClientObj).map((key, index) => {
            if (_.has(fields, key)) {
                setFieldsClient((dreft) => {
                    dreft[key] = fields[key]
                })
            }
        })
    }

    /**
     *
     * @param client
     */
    const updateClientForJob = (client: ClientT) => {
        let key = props.typeClient == "primary" ? "client" : "billingContact"
        props.updateJob(key, client)
    }

    /**
     * saveClient
     */
    const saveClient = async (event): Promise<string> => {
        let parmas = { ...fieldsClient }
        // console.log("saveClient->fieldsClient", fieldsClient)

        let url = `${config.url.clients}`;
        if (mode == "edit" && fieldsClient.id != null) {
            url = `${url}/${fieldsClient.id}`
        } else {
            // parmas = { ...fieldsClient }
            if (_.has(parmas, "id")) {
                // @ts-ignore
                delete parmas.id
            }
        }

        try {
            let key = props.typeClient == "primary" ? "client" : "billingContact"
            props.updateJob(key, fieldsClient)

            let res = await AxiosInstance.post(`${url}`, parmas)
            if (res && res.data) {

                if (props.jobMode == JobMode.Edit) {
                    if (!props.customSaveJob) throw new Error("this mode not allow save.")
                    let args = {
                        [key]: { ...fieldsClient, ...res.data }
                    }
                    let resJob = await props.customSaveJob(args as JobT)
                    setTimeout(() => { restState() }, 1000);
                    if (resJob) return "Client saved."
                } else {
                    setTimeout(() => { restState() }, 1000);
                    return "Client saved."
                }


            }
            throw new Error("Client saved fail.")
        } catch (error) {
            throw error;
        }
    }




    return (
        <Form>
            <div className="d-flex flex-sm-row flex-column">
                <div className="d-flex  flex-column flex-md-fill flex-lg-fill " style={{ maxWidth: 400, minWidth: 400 }}>
                    {props.typeClient == "primary" && <div>

                        <Image
                            src={fieldsClient && fieldsClient.profilePic ? fieldsClient.profilePic : images.noProfilePic}
                            style={{ width: 200, height: 200 }} />
                        <br />
                        {props?.jobMode != JobMode.Dispute && <ButtonUploadImage
                            type="button"

                            accept={"image/png, image/jpeg"}
                            onChangeFile={(file) => {
                                // updateClient("profilePic", file.uri)
                                try {
                                    uploadFileServer(file).then((res) => {
                                        if (res.source_url) {
                                            updateClient("profilePic", res.source_url)
                                        }
                                    })
                                } catch (error) {

                                }
                            }}
                            className="btn-link  mt-2" >
                            Update Profile Pic
                        </ButtonUploadImage>}
                    </div>}
                </div>
                <div className="d-flex flex-column flex-md-fill flex-lg-fill ">
                    <Form.Group>
                        <h3>{props.typeClient == "primary" ? "Primary Contact" : "Billing Contact"}</h3>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
                            <span>
                                <Form.Label>First Name</Form.Label>
                                <Form.Control className='input-material'
                                    disabled={disabled}
                                    value={`${fieldsClient.firstName}`}
                                    onChange={(event: any) => { updateClient('firstName', event.target.value) }} />
                            </span>
                            <span>
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control className='input-material'
                                    disabled={disabled}
                                    value={`${fieldsClient.lastName}`}
                                    onChange={(event: any) => { updateClient('lastName', event.target.value) }} />
                            </span>
                            <span>
                                <Form.Label>Phone</Form.Label>
                                <InputPhone
                                    disabled={disabled}
                                    className="input-material"
                                    defaultValue={`${fieldsClient.phone}`}
                                    value={`${fieldsClient.phone}`}
                                    onChangeValue={val => { updateClient('phone', val) }} />
                            </span>
                            <span>
                                <Form.Label>Email</Form.Label>
                                <InputSearchClients
                                    disabled={disabled}
                                    // style={{ fontSize: '2em' }}
                                    onChangeText={(text) => {
                                        updateClient('email', text)
                                    }}
                                    textValue={`${fieldsClient.email}`}
                                    onSelectUser={(user) => {
                                        const cloneClient = { ...copyObject(ClientObj), ...user }
                                        console.log("cloneClient", cloneClient)
                                        setAllFieldsClient(cloneClient)

                                        updateClientForJob(cloneClient)

                                        // setFieldsDirty(cloneClient)
                                        setAction("change")
                                        setMode("edit")
                                    }} />
                            </span>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '4fr 1fr' }}>
                            <span>
                                <Form.Label>Address</Form.Label>
                                <GoogleMapAutoComplete
                                    disabled={disabled}
                                    idAddresss="jobClient"
                                    className='input-material'
                                    apiKey={config.keyMap}
                                    onChangeText={text => { }}
                                    onPress={async location => {
                                        updateClient("address", location.verbose_address)
                                    }}

                                    placeholder=''
                                    textValue={`${fieldsClient.address}`}
                                />
                            </span>
                            <span>
                                <Form.Label>Address 2</Form.Label>
                                <Form.Control className='input-material'
                                    disabled={disabled}
                                    value={`${fieldsClient.address2}`}
                                    onChange={(event: any) => { updateClient('address2', event.target.value) }} />
                            </span>
                        </div>
                        <Form.Check
                            // custom
                            className='mt-2'
                            id={`custom-clientIsCompany-${props.typeClient}`}
                            checked={fieldsClient.isCompany}
                            type="checkbox"
                            label='Is company?'
                            onChange={(): void => {
                                let checked = fieldsClient.isCompany == true ? false : true
                                updateClient('isCompany', !fieldsClient.isCompany)
                            }}
                        />

                        {fieldsClient.isCompany && <>
                            <Form.Label>Company Name</Form.Label>
                            <Form.Control className='input-material' />
                        </>}
                        {props.typeClient == "primary" && <Form.Check
                            // custom
                            className='mt-2'
                            id={`${"custom-"}${props.isBillingContact}-isBillingContact`}
                            checked={props.isBillingContact == true ? true : false}
                            type="checkbox"
                            label='Is billing contact?'
                            onChange={(): void => {
                                if (props.updateJob) {
                                    let checked = props.isBillingContact == true ? false : true
                                    props.updateJob('isBillingContact', checked)
                                }
                            }}
                        />}


                        {(mode == "edit" && props?.jobMode != JobMode.Dispute) &&
                            <ChangePassword client={props.client} />}


                        {props?.jobMode != JobMode.Dispute && <div className="d-flex justify-content-start">
                            <ButtonLoading
                                style={{ margin: 0 }}
                                // onPress={(): void => { clickedSaveJob() }}
                                // type="button"
                                // positionMessage={"Bottom"}
                                onClickFetching={saveClient}
                                className="btn-success mt-5">{props.typeClient == "primary" ? "Save Client" : "Save Billing Contact"}</ButtonLoading>
                        </div>}

                    </Form.Group>

                </div>
            </div>

        </Form>


    );
}

FormEditClient.defaultProps = {
    typeClient: "primary"
}
export default React.memo(FormEditClient)
